import { DemoRadioControl } from '@/components/Demo';

import FlexDemo from './FlexDemo';
import Output from './Output';
import Item from './Item';

function AutoMargins() {
  return (
    <FlexDemo
      initialValues={{
        marginLeft: 0,
        marginRight: 0,
      }}
      controls={[
        <DemoRadioControl
          inline
          key="marginLeft"
          id="marginLeft"
          label="margin-left"
          options={[{ label: '0 (default)', value: 0 }, 'auto']}
          wrapperStyle={{
            color: 'hsl(50deg 100% 65%)',
          }}
        />,
        <DemoRadioControl
          inline
          key="marginRight"
          id="marginRight"
          label="margin-right"
          options={[{ label: '0 (default)', value: 0 }, 'auto']}
          wrapperStyle={{
            color: 'hsl(50deg 100% 65%)',
          }}
        />,
      ]}
    >
      {({ marginLeft, marginRight }) => {
        return (
          <Output>
            <Item
              primary
              style={{ flexBasis: 64, marginLeft, marginRight }}
            />
            <Item style={{ flexBasis: 64 }} />
            <Item style={{ flexBasis: 64 }} />
          </Output>
        );
      }}
    </FlexDemo>
  );
}

export default AutoMargins;
